import { Component, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MediaService } from '../../media.service';

@Component({
  standalone: false,
  selector: 'media-upload',
  templateUrl: './template.html',
  styleUrl: './style.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MediaUploadComponent,
      multi: true,
    },
  ],
})
export class MediaUploadComponent {
  @Output() imageUploaded = new EventEmitter<string>();
  fileToUpload: File | null = null;
  isLoading = false;
  dragOver = false;

  constructor(private mediaService: MediaService) {}

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.fileToUpload = event.dataTransfer.files.item(0);
      this.upload();
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
  }

  onFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files: FileList = fileInput.files as FileList;
    this.fileToUpload = files.item(0) as File;
    this.upload();
  }

  async upload() {
    if (!this.fileToUpload) {
      return;
    }
    this.isLoading = true;
    const imageId = await this.mediaService.uploadImageToLibrary(this.fileToUpload);
    this.imageUploaded.emit(imageId);
    this.isLoading = false;
  }
}
